import { StatusPillLevel } from "../../components/ui/StatusPill";

export const SUBSCRIPTION_STATUS_LEVEL: Record<string, StatusPillLevel> = {
  approved: "success",
  pending: "warning",
  rejected: "error",
  cancelled: "error",
  superseded: "neutral",
};

export const getSubscriptionStatusLevel = (status: string): StatusPillLevel =>
  SUBSCRIPTION_STATUS_LEVEL[status] ?? "neutral";

export const getSubscriptionStatusLabel = (
  intl: { formatMessage: (descriptor: { id: string }) => string },
  status: string
): string =>
  SUBSCRIPTION_STATUS_LEVEL[status]
    ? intl.formatMessage({ id: `subscriptionDetail.status.${status}` })
    : status;
